import { Button, Checkbox, Card, Typography, Row, Col } from 'antd';
import React, { useState, useEffect } from 'react';
import { ErrorConnectionFailed, SendToBackend } from '../../shared/HelperContactBackend';
import '../../styles/Stepper.css';
const { Title } = Typography;

export const FormConsent = ({ next, prev, platform, setPlatform, sessionId }) => {

    const [nConsent, setNConsent] = useState(0);

    const [Pdf, setPdf] = useState(process.env.PUBLIC_URL + '/documents/consent-form-chatbot.pdf');
    const [platformName, setPlatformName] = useState("Platform");

    useEffect(() => {
        switch (platform) {
        case "chatgpt":
            setPlatformName("ChatGPT");
            break;
        case "gemini":
            setPlatformName("Gemini");
            break;
        case "claude":
            setPlatformName("Claude");
            break;
        case "deepseek":
            setPlatformName("DeepSeek");
            break;
        case "mistral":
            setPlatformName("Mistral");
            break;
        case "grok":
            setPlatformName("Grok");
            break;
        default:
            setPlatformName("Platform");
        }; 
        setPdf(process.env.PUBLIC_URL + '/documents/consent-form-chatbot.pdf');
    }, [platform]);

    const checkBoxes = [
        {
            key: "18",
            text: "I am 18 years of age or older"
        },
        {
            key: "read",
            text: "I have read this consent form in its entirety or had it read to me"
        },
        {
            key: "voluntary",
            text: "I voluntarily consent to participate in this research"
        },
        {
            key: "use",
            text: "I have used " + (platformName) + " for a time period of 3 months or more"
        },
        {
            key : "risk",
            text : "I understand the risks of sharing my " + (platformName) + " data"
        }
    ];

    // Expects an array
    const onChange = (checkedValues) => {
        setNConsent(checkedValues.length);
    };

    const onNext = () => {
        var consentData = JSON.stringify({
            "session_id": sessionId.session_id,
            "consented_for": {"declarations": checkBoxes}
        });
        SendToBackend(
            consentData,
            'consents/upsert/',
            next,
            ErrorConnectionFailed);
    }

    function ConsentFormItem({ title, text }) {
        return (
            <Card title={title} key={title} className="Text">
                {text}
            </Card>
        );
    };

    function ConsentCheckBox({ text }) {
        return (
            <Row className="TopMargin">
                <Col>
                    <Checkbox
                        key={text}
                        value={text}
                        className="ConsentText"
                    >
                        {text}
                    </Checkbox>
                </Col>
            </Row>
        );
    }

    return (
        <div align="center">
            <Title >
                Please review the consent form and confirm the following statements
            </Title>
            <table
            border="1"
            cellPadding="8"
            cellSpacing="0"
            style={{ borderCollapse: "collapse", width: "100%" }}
            >
            <tbody>
                <tr>
                <th style={{ width: "20%" }}>Project Title</th>
                <td>Understanding the Dynamics of Human-Chatbot Interactions</td>
                </tr>

                <tr>
                <th>Purpose of the Study</th>
                <td>
                    This research is conducted by Krishna P. Gummadi and Abhisek Dash at the Max Planck Institute for Software Systems; 
                    Ingmar Weber at Saarland University; Savvas Zannettou at Delft University of Technology; 
                    Animesh Mukherjee and Sai Keerthana Karnam at the Indian Institute of Technology, Kharagpur; 
                    and Asmaa El Fraihi at Inria Saclay and the Polytechnic Institute of Paris. This project explores how users interact with AI-driven chatbots.
                </td>
                </tr>

                <tr>
                <th>Procedures</th>
                <td>
                    The procedure involves completing several steps including: completing an online survey, 
                    reading and approving this consent form, selecting the platform(s) from which you wish to donate data,
                    requesting and downloading your data from those platform(s), specifying your data-sharing preferences, and uploading the files to our secure framework.
                </td>
                </tr>

                <tr>
                <th>Potential Risks and Discomforts</th>
                <td>
                    Some of the data may be inherently sensitive potentially having
                    deanonymization risks. Therefore, all of your data (survey data +
                    donated data) will be stored in secured servers with strict access
                    controls. Hence, we believe that there are no risks above those normally
                    encountered on the internet anticipated from participating in this
                    study.
                </td>
                </tr>

                <tr>
                <th>Potential Benefits</th>
                <td>
                    Apart from the monetary remunerations for the participants, we hope
                    that, in the future, multiple stakeholders (e.g., end-users,
                    researchers, policymakers etc.) might benefit from this study through
                    improved understanding of human-AI interaction and systemic risks (if
                    any) that may result from such interactions.
                </td>
                </tr>

                <tr>
                <th>Confidentiality</th>
                <td>
                    To protect participants, all data will be collected and stored using
                    coded identifiers that allow linking the participant’s shared output
                    files with their survey responses, but do not connect to the
                    participant’s identity. However, the risk of de-identification still
                    exists. Therefore, to protect participants' privacy, the conversation
                    data is stored on secure, access-controlled servers for research,
                    meaning study data will be accessible only to the investigators.
                    Collected data will be destroyed within 36 months (after the completion
                    of this project).
                    <br />
                    <br />
                    If we write a report or article about this research project, your
                    identity will be protected to the maximum extent possible. Your
                    information may be shared with governmental authorities if you or
                    someone else is in danger or if we are required to do so by law.
                </td>
                </tr>

                <tr>
                <th>Compensation</th>
                <td>
                    You will be compensated pursuant with your agreement with Prolific for
                    your participation. You will be responsible for any taxes assessed on
                    the compensation.
                </td>
                </tr>

                <tr>
                <th>Right to Withdraw and Questions</th>
                <td>
                    Your participation in this research is completely voluntary. You may
                    choose not to take part at all. If you decide not to participate in this
                    research, you may stop participating at any time. In such a case, if you
                    so wish please contact us for the removal of the data from our database.
                    <br />
                    For any further questions, concerns, or complaints, or if you need to
                    report an injury related to the research, please contact the
                    investigator:
                    <br />
                    <strong>Krishna P. Gummadi</strong>
                    <br />
                    Max Planck Institute for Software Systems
                    <br />
                    Campus E1 5
                    <br />
                    66123 Saarbrücken, Germany
                    <br />
                    <a href="mailto:gummadi@mpi-sws.org">gummadi@mpi-sws.org</a>
                </td>
                </tr>
            </tbody>
            </table>

            <a href = {Pdf} target = "_blank">For more details, download the full consent form in pdf format</a>

            <Checkbox.Group style={{ width: '100%' }} onChange={onChange}>
                {checkBoxes.map((item) => (
                    <ConsentCheckBox {...item} />
                ))}
            </Checkbox.Group>

             <br></br>
            <Button
                className="RightMargin"
                onClick={() => {prev();}}>
                Previous
            </Button> 
            
            <Button
                type="primary"
                disabled={!(nConsent === checkBoxes.length)}
                onClick={onNext}>
                Next
            </Button>
        </div>
    )
};

export default FormConsent;